import React from "react"
export default function useChartLoader(ms: number = 1300) {
    const [loading, setIsLoading] = React.useState(true)
    React.useEffect(() => {
        const fetchData = async () => {
            await new Promise(resolve => setTimeout(resolve, ms))
            setIsLoading(false)
        }
        fetchData()
    }, [ms])
    const isLoaded: React.CSSProperties = {
        visibility: loading ? "hidden" : "initial"
    }
    return {loading, isLoaded}
}
